import React from 'react';
import {useTranslation} from 'react-i18next';
import './style.less';

// Rendered by @rollbar/react's ErrorBoundary once a render has thrown. The error has
// already been sent to Rollbar by the time this mounts — this is only the way out for
// the landlord: retry the subtree, or reload if the state is too far gone.
const ErrorFallback = ({error, resetError}) => {

    const {t} = useTranslation();

    return (
        <div className="ErrorFallback">
            <div className="content">
                <p className="title">{t('error.boundary.title')}</p>
                <p className="info">{t('error.boundary.info')}</p>
                {process.env.NODE_ENV === 'development' && error &&
                    <pre className="details">{error.message}</pre>}
                <div className="actions">
                    <button type="button" className="secondary" onClick={resetError}>
                        {t('error.boundary.retry')}
                    </button>
                    <button type="button" onClick={() => window.location.reload()}>
                        {t('error.boundary.reload')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ErrorFallback;
